import { useState, useEffect } from 'react';
import { Wheel } from 'react-custom-roulette';
import dateNightIdeas from '../data/dateNightIdeas.json';
import '../styles/DateNightSpinner.css'; // Import your CSS file for styling
import AddIdea from '../components/AddIdea';

// Date night ideas: https://www.reddit.com/r/LDR/comments/q0eup6/masterlist_of_ldr_activities_credits_to_original/?utm_source=share&utm_medium=ios_app&utm_name=iossmf

const DateNight = () => {
    const [filteredIdeas, setFilteredIdeas] = useState(dateNightIdeas);
    const [selectedIdea, setSelectedIdea] = useState(null);
    const [tags, setTags] = useState([]);
    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [showPopup, setShowPopup] = useState(false); // State to control popup visibility
    const [showNoMatchesPopup, setShowNoMatchesPopup] = useState(false); // State for "No Matches" popup
    const [excludedIdeas, setExcludedIdeas] = useState([]); // State to track excluded ideas
    // const [newData, setNewData] = useState(dateNightIdeas); // Variable to hold filtered ideas after excluding
    // const [showAddIdeaPopup, setShowAddIdeaPopup] = useState(false); // State for Add Idea popup

    useEffect(() => {
        filterIdeas();
        
    }, [tags, excludedIdeas]); // Re-run filter when tags or excluded ideas change


    const uniqueTags = Array.from(
        new Set(dateNightIdeas.flatMap((idea) => idea.tags))
    );

    const filterIdeas = () => {
        // console.log("Filtering ideas");
        // console.log("newData:", newData);

        // if there are no tags selected, show all ideas
        if (tags.length === 0 && excludedIdeas.length === 0) {
            setShowNoMatchesPopup(false);
            setFilteredIdeas(dateNightIdeas);
        } else {
            // Filter ideas based on selected tags
            const filtered = dateNightIdeas.filter((idea) =>
                idea.tags &&
                tags.every((tag) => idea.tags.includes(tag.trim())) &&
                !excludedIdeas.includes(idea.idea) // Exclude ideas that are marked as excluded
            );

            console.log("Filtered Ideas:", filtered);

            // Show "No Matches" popup if no ideas match the filters
            if (filtered.length === 0) {
                setFilteredIdeas([]);
                setShowNoMatchesPopup(true);
            } else {
                setFilteredIdeas(filtered);
                setShowNoMatchesPopup(false);


            }
            
        }

        // console.log("Filtered Ideas:", filteredIdeas);

        // // Exclude ideas that are in the excludedIdeas state
        // const finalData = filteredIdeas.filter((idea) => !excludedIdeas.includes(idea.idea));

        // console.log("Final Data after excluding:", finalData);
        // setNewData(finalData);

        // if (finalData.length === 0) {
        //     setShowNoMatchesPopup(true);   
        //     console.log("newData.length === 0");
     
        // }
        // console.log("newData:", newData);
    };


    // if idea meets filter criteria and is not in excludedIdeas, return true
    const containsIdea = (idea) => {
        return filteredIdeas.some((filteredIdea) => filteredIdea.idea === idea) || 
               excludedIdeas.includes(idea);
    }

    const handleTagChange = (tag) => {
        setTags((prevTags) => {
            if (prevTags.includes(tag)) {
                // Remove the tag if it already exists
                return prevTags.filter((t) => t !== tag);
            } else {
                // Add the tag if it doesn't exist
                return [...prevTags, tag];
            }
        });
        console.log("Tags after change:", tags);
    };

    const handleExcludeIdea = (idea) => {
        setExcludedIdeas((prevExcluded) => {
            if (prevExcluded.includes(idea)) {
                // Remove the idea from excluded list
                return prevExcluded.filter((excluded) => excluded !== idea);
            } else {
                // Add the idea to excluded list
                return [...prevExcluded, idea];
            }
        });
    };
    
    const spinWheel = () => {
        if (filteredIdeas.length > 0) {
            const randomIndex = Math.floor(Math.random() * filteredIdeas.length);
            setPrizeNumber(randomIndex);
            setMustSpin(true);
        } else {
            setSelectedIdea("No ideas match the selected filters.");
        }
    };

    const handleSpinComplete = () => {
        setMustSpin(false);
        setSelectedIdea(filteredIdeas[prizeNumber].idea);
        setShowPopup(true); // Show popup when an idea is selected
    };

    // let newData = filteredIdeas.filter((idea) => !excludedIdeas.includes(idea.idea));
    

    const data = filteredIdeas.map((idea, index) => ({
        option: idea.idea,
        image: {
            uri: '/coffee.png',
            offsetX: 5, 
            offsetY: 155,
            sizeMultiplier: 0.3, 
            landscape: false 
        },
        style: { 
            textAlign: 'center',
            wordWrap: 'break-word',
            padding: '5px',
            fontSize: '15',
        }
    }));
  

    return (
        <div className="background" style={{backgroundImage: 'url(/bgnd.png)'}} >
            
            {/* <button className="add-idea" onClick={() => setShowAddIdeaPopup(true)}>Add Idea</button> */}
            {/* { showAddIdeaPopup && <AddIdea onClose={() => setShowAddIdeaPopup(false)} />} */}

            {!showNoMatchesPopup && (
            <div className='noMatch'>
                <h1 style={{
                    color: 'rgb(238, 234, 221)',
                    fontWeight: 'bold'
                }}>Remote Date Night Spinner</h1>
                
                 {/* Spin the Wheel Button */}
                 <button 
                    onClick={spinWheel} 
                    className='spinBtn'
                >Spin the Wheel</button>
                <div style={{ margin: '2em 0' }}>
                    <Wheel
                        mustStartSpinning={mustSpin}
                        prizeNumber={prizeNumber}
                        data={data}
                        onStopSpinning={handleSpinComplete}

                        backgroundColors= {['#669966', '#CCCC99','#336633', '#999966','#006633', '#339966', '#669933']}

                        textColors={['rgb(238, 234, 221)', 'rgb(125, 123, 116)','rgb(238, 234, 221)', 'rgb(238, 234, 221)','rgb(238, 234, 221)', 'rgb(238, 234, 221)', 'rgb(238, 234, 221)']}

                        outerBorderColor={['rgb(238, 234, 221)']}
                        outerBorderWidth={['5']}

                        radiusLineColor={['rgb(238, 234, 221)']}
                        radiusLineWidth={['5']}

                        innerBorderColor={['rgb(238, 234, 221)']}
                        innerRadius={['0']}
                        innerBorderWidth={['7']}
                        

                        fontSize={['10']}
                        textDistance={['53']}
                    />
                </div>
                
                {/* Popup for Selected Idea */}
                {showPopup && (
                    <div className="idea-popup">
                        <div className='idea-popup-content'>
                            <p style={{fontSize: 19}}>Selected Idea</p>
                            <h1 
                                style={{ wordWrap: 'break-word' }}>{selectedIdea}

                            </h1>
                            <button onClick={() => setShowPopup(false)} className='idea-btn'>Yass!</button>
                        </div>
                    </div>
                )}
            </div>
            )}
            
            <div className="filter-container">
                <p className='filter-text'>Filter</p>
                <div className='filter-options'>
                <div className='filter-options'>
                    {uniqueTags.map((tag) => (
                        <label key={tag}>
                            {tag}: <input type="checkbox" onChange={() => handleTagChange(tag)} />
                        </label>
                    ))}
                </div>
                </div>
                <p className='filter-text'>All Options</p>
                <div className='filter-options'>
                    {dateNightIdeas.map((date) => (
                        <label key={date.idea} style={{ color: containsIdea(date.idea) ? 'white' : 'rgb(204, 204, 204)' }}>
                            <input
                                type="checkbox"
                                checked={containsIdea(date.idea) && !excludedIdeas.includes(date.idea)}
                                onChange={() => handleExcludeIdea(date.idea)}
                                disabled={!containsIdea(date.idea)}
                            />
                            {date.idea}
                        </label>
                    ))}
                </div>
                {showNoMatchesPopup && (
                    <div className='no-matches-popup'>
                        <p style={{ fontSize: 16, color: 'red' }}>No matches found for the selected filters!</p>
                    </div>
                )}
                
            </div>
            
            
        </div>

    );

}

export default DateNight;